import { object } from "prop-types"
import { Menu, MenuButton, MenuList, MenuLink } from "@reach/menu-button"
import { StackView } from "@planningcenter/tapestry-react"
import Icon from "components/planning_center_icon"
import { api } from "utils/api"

const EmailActions = ({ paths = {} }) => {
  const handleResendEmail = () => {
    return alertModal(
      {
        title: "Resend email?",
        text: "Do you want to resend the confirmation email?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No, don't send it",
        confirmButtonText: "Yes, send it!",
        closeOnConfirm: false
      },
      () => {
        api.post(paths.confirmEmail).then(_resp => {
          alertModal({
            title: "Success!",
            type: "success",
            confirmButtonText: "Ok",
            closeOnConfirm: true
          })
        })
      }
    )
  }
  return (
    <StackView axis="horizontal" distribution="flex-end" marginTop={1}>
      <Menu>
        <MenuButton className="sm-btn quiet-btn btn2">
          Email
          <span data-reach-menu-button-toggle-icon>
            <Icon symbol="general#down-caret" />
          </span>
        </MenuButton>
        <MenuList css={{ whiteSpace: "nowrap" }}>
          <MenuLink data-modal-url={paths.newEmail}>Send email</MenuLink>
          <MenuLink onClick={handleResendEmail}>Resend confirmation email</MenuLink>
        </MenuList>
      </Menu>
    </StackView>
  )
}

EmailActions.propTypes = {
  paths: object
}

export default EmailActions
